import { useNavigate, useSearchParams } from 'react-router-dom';
import { RrcLocationProfileInspector } from '@ots-frontend/ots-ui-tw';
export const RrcLocationProfileProfilePageRoute = () => {
  const [params] = useSearchParams();
  return (
    <RrcLocationProfileProfilePage
      id={params.get('id') ?? undefined}
      tenantCode={params.get('tenantCode') ?? undefined}
    />
  );
};
export const RrcLocationProfileProfilePage = ({
  id,
  tenantCode,
}: {
  id?: string;
  tenantCode?: string;
}) => {
  const navigate = useNavigate();
  return (
    <RrcLocationProfileInspector
      id={id}
      tenantCode={tenantCode}
      presentation="embedded"
      onClose={() => navigate(-1)}
    />
  );
};
